import { getWarehouse } from 'helpers/api';

const state = {
    interval: null,
    container: null,
    time: null,
    end: null,
    remaining: {
        hour: null,
        minute: null,
    },
    elements: {
        hour: null,
        minute: null,
    },
    UTCOffset: null,
};

// ==================================================
// INITIALIZERS
// ==================================================

async function setDefaultState() {
    [state.container] = document.getElementsByClassName('js--daily-promo');
    [state.elements.hour] = state.container.getElementsByClassName('js--daily-promo-hour');
    [state.elements.minute] = state.container.getElementsByClassName('js--daily-promo-minute');
    state.end = state.container.getAttribute('data-end');
    state.UTCOffset = await getWarehouse();
}

// ==================================================
// HANDLERS
// ==================================================

function handleCountDownInit() {
    const keys = Object.keys(state.elements);
    const date = new Date();
    date.setHours(date.getUTCHours() - state.UTCOffset);
    const start = date.getTime();
    const end = state.time || getEndDate(date);
    let timeRemaining = parseInt((end - start) / 1000, 10);
    if (timeRemaining >= 0) {
        state.remaining.hour = parseInt(timeRemaining / 3600, 10);
        timeRemaining %= 3600;
        state.remaining.minute = parseInt(timeRemaining / 60, 10);

        return keys.forEach((k) =>
            parseInt(state.elements[k].innerHTML, 10) !== state.remaining[k]
                ? (state.elements[k].innerHTML = state.remaining[k])
                : null,
        );
    }

    keys.forEach((k) => (state.elements[k].innerHTML = 0));
    clearInterval(state.interval);
}

// ==================================================
// HELPERS
// ==================================================

function getEndDate(date) {
    const endDate = date;
    endDate.setSeconds(0);
    endDate.setHours(parseInt(state.end.slice(0, 2), 10));
    endDate.setMinutes(parseInt(state.end.slice(2), 10));
    state.time = endDate.getTime();

    return state.time;
}

// ==================================================
// INIT
// ==================================================

function init() {
    setDefaultState();
    state.interval = setInterval(handleCountDownInit, 1000);
}

export default init;
